import { LinkTypes } from "src/contexts/_shared/domain/LinkType";
import { LocaleConfig } from "../domain/LocaleConfig";
import { TranslationRepository } from "../domain/TranslationRepository";
import { DocumentationAreaId } from "src/contexts/documentationArea/domain/DocumentationAreaId";
import { ActorId } from "src/contexts/documentationArea/domain/ActorId";

type TranslationControllerOptions = {
  translationRepository: TranslationRepository;
};

export class TranslationController {
  private readonly translationRepository: TranslationRepository;

  constructor({ translationRepository }: TranslationControllerOptions) {
    this.translationRepository = translationRepository;
  }

  public async getTranslation(locale: string, slug: string, linkType: LinkTypes) {
    return await this.translationRepository.getTranslations(locale, slug, linkType);
  }

  public async getTranslationByDocumentationAreaId(
    locale: string,
    documentationAreaId: DocumentationAreaId,
    accessToken: string,
  ): Promise<Record<string, string>> {
    return await this.translationRepository.getTranslationsByDocumentationAreaId(
      locale,
      documentationAreaId,
      accessToken,
    );
  }

  public async getLocaleConfig(slug: string, linkType: LinkTypes): Promise<LocaleConfig> {
    return await this.translationRepository.getLocaleConfig(slug, linkType);
  }

  public async getLocaleConfigByDocumentationAreaId(
    documentationAreaId: DocumentationAreaId,
    actorId: ActorId,
    token: string,
  ): Promise<LocaleConfig> {
    return await this.translationRepository.getLocaleConfigByDocumentationAreaId(
      documentationAreaId,
      actorId,
      token,
    );
  }
}
